__turbopack_context__.v({
  "className": "noto_serif_31868fe1-module__Sp_6Pq__className",
  "variable": "noto_serif_31868fe1-module__Sp_6Pq__variable",
});
